import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true, timeout: 15000 });

let refreshing = null;
const wait = (ms) => new Promise((r) => setTimeout(r, ms));
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (!cfg) return Promise.reject(error);
    const status = error.response?.status;
    if (cfg.method === "get" && (!error.response || status >= 500) && (cfg._tries || 0) < 3) {
      cfg._tries = (cfg._tries || 0) + 1;
      await wait(600 * cfg._tries);
      return api(cfg);
    }
    if (status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export const ACCESS_LABEL = { public: "Free", free: "Members", premium: "Members", coaching: "Members", paid: "Purchase" };

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }) : "");
